import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 7: Show them that you have
                                                delivered
                                            </div>
                                            <p>Once committed, stakeholders will want to know about the rewards
                                                and benefits of investing
                                                their reputation, time or other resources. Closely monitor all
                                                effort and achievement at every
                                                stage of the project and make sure you communicate benefits to
                                                the business as a whole. If there
                                                were people who expressed doubt or misgivings at the start, this
                                                will help win them over, too!</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">BUILDING YOUR CASE</span>
                                            </div>
                                            <p>Organise your case! Collect evidence to support your idea and
                                                check the following:</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/buildimage.png')}
                                                    alt="" className="" useMap="#Map"/>
                                            </div>

                                            <map name="Map" id="Map">
                                                <area shape="rect" coords="291,25,494,110"
                                                      onMouseOver="Tip('Not just about your own idea but possible alternatives, too. What potential competition is there? Try to establish as much information and background data as possible.', TITLE, this.innerHTML, PADDING, 9, WIDTH, 170, TITLEBGCOLOR, '#FDB83B', BGCOLOR, '#FEEFD4', BORDERCOLOR, '#FDB83B', TITLEFONTSIZE, '12px',FONTFACE,'EK_MUKTALIGHT,SAN-SERIF',FONTSIZE,'15px');"
                                                      onMouseOut="UnTip()"/>

                                                <area shape="rect" coords="371,94,580,186"
                                                      onMouseOver="Tip('Make it clear how your idea aligns with or promotes the business’ goals and objectives.', TITLE, this.innerHTML, PADDING, 9, WIDTH, 170, TITLEBGCOLOR, '#FDB83B', BGCOLOR, '#FEEFD4', BORDERCOLOR, '#FDB83B', TITLEFONTSIZE, '12px',FONTFACE,'EK_MUKTALIGHT,SAN-SERIF',FONTSIZE,'15px');"
                                                      onMouseOut="UnTip()"/>

                                                <area shape="rect" coords="233,178,430,258"
                                                      onMouseOver="Tip('Show that your idea accords with best practice by demonstrating its integrity and that it won’t compromise the business’s reputation or working partnerships.', TITLE, this.innerHTML, PADDING, 9, WIDTH, 170, TITLEBGCOLOR, '#FDB83B', BGCOLOR, '#FEEFD4', BORDERCOLOR, '#FDB83B', TITLEFONTSIZE, '12px',FONTFACE,'EK_MUKTALIGHT,SAN-SERIF',FONTSIZE,'15px');"
                                                      onMouseOut="UnTip()"/>

                                                <area shape="rect" coords="158,259,358,347"
                                                      onMouseOver="Tip('Check whether the law or internal policies and practices support or hinder any of your arguments.', TITLE, this.innerHTML, PADDING, 9, WIDTH, 170, TITLEBGCOLOR, '#FDB83B', BGCOLOR, '#FEEFD4', BORDERCOLOR, '#FDB83B', TITLEFONTSIZE, '12px',FONTFACE,'EK_MUKTALIGHT,SAN-SERIF',FONTSIZE,'15px');"
                                                      onMouseOut="UnTip()"/>

                                                <area shape="rect" coords="253,340,450,430"
                                                      onMouseOver="Tip('What’s different about your idea? Find a way to express its unique logic or creativity to capture and ‘hook’ your audience’s interest and imagination.', TITLE, this.innerHTML, PADDING, 9, WIDTH, 170, TITLEBGCOLOR, '#FDB83B', BGCOLOR, '#FEEFD4', BORDERCOLOR, '#FDB83B', TITLEFONTSIZE, '12px',FONTFACE,'EK_MUKTALIGHT,SAN-SERIF',FONTSIZE,'15px');"
                                                      onMouseOut="UnTip()"/>

                                                <area shape="rect" coords="519,407,319,510"
                                                      onMouseOver="Tip('If you demonstrate that you have ‘done your homework’ and sincerely believe in your idea, your enthusiasm will be contagious!', TITLE, this.innerHTML, PADDING, 9, WIDTH, 170, TITLEBGCOLOR, '#FDB83B', BGCOLOR, '#FEEFD4', BORDERCOLOR, '#FDB83B', TITLEFONTSIZE, '12px',FONTFACE,'EK_MUKTALIGHT,SAN-SERIF',FONTSIZE,'15px');"
                                                      onMouseOut="UnTip()"/>
                                            </map>
                                            <div className="border_subtitle">Get the facts right</div>
                                            <p>Try to establish as much information and background data as
                                                possible, not just about your own idea but possible alternatives
                                                too. Consider both the benefits and risks.</p>
                                            <div className="border_subtitle">The business reasons</div>
                                            <p>Make it clear how your idea aligns with or promotes the
                                                business’s goals and objectives.</p>
                                            <div className="border_subtitle">The ethical approach</div>
                                            <p>Show that your idea accords with best practice by demonstrating
                                                its integrity and that it won’t compromise the business’s
                                                reputation or working partnerships.</p>
                                            <div className="border_subtitle">The legal standpoint</div>
                                            <p>Check whether the law or internal policies and practices support
                                                or hinder any of your arguments.</p>
                                            <div className="border_subtitle">Your Unique Selling Points (USPs)
                                            </div>
                                            <p>What’s different about your idea? Find a way to express its
                                                unique logic or creativity to capture and ‘hook’ your audience’s
                                                interest and imagination.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}